import React from "react";

function DocIcon() {
  return (
    <svg
      width="19"
      height="23"
      viewBox="0 0 19 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.25 7.25L11.25 1.25H3.25C2.71957 1.25 2.21086 1.46071 1.83579 1.83579C1.46071 2.21086 1.25 2.71957 1.25 3.25V19.25C1.25 19.7804 1.46071 20.2891 1.83579 20.6642C2.21086 21.0393 2.71957 21.25 3.25 21.25H15.25C15.7804 21.25 16.2891 21.0393 16.6642 20.6642C17.0393 20.2891 17.25 19.7804 17.25 19.25V7.25ZM11.25 1.25V7.25H17.25M13.25 12.25H5.25M13.25 16.25H5.25M7.25 8.25H5.25"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DocIcon;
